(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ds-collection"]) return;
  try {
    
document.addEventListener('change',event=>{if(event.target.matches('[data-team-filter]')){const url=new URL(event.target.value,location.origin);const sort=new URL(location.href).searchParams.get('sort_by');if(sort)url.searchParams.set('sort_by',sort);location.assign(url);}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-product"]) return;
  try {
    
function initialiseDunkSupplyProducts(){
  document.querySelectorAll('[data-ds-product]:not([data-ready])').forEach(root=>{
    root.dataset.ready='true';
    const product=JSON.parse(root.querySelector('[data-product-json]').textContent);
    const form=root.querySelector('form');
    const select=root.querySelector('[data-variant-select]');
    const custom=root.querySelector('[data-customise]');
    const customFields=root.querySelector('[data-custom-fields]');
    const selected=product.variants.find(v=>String(v.id)===select.value)||product.variants[0];
    const suffix=' · Custom name & number';
    const names=product.options.map(o=>typeof o==='string'?o:o.name);
    const versionIndex=names.findIndex(x=>x.toLowerCase()==='version');
    const personalisationIndex=names.indexOf('Personalisation');
    const format=value=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:root.dataset.currency||'EUR'}).format(value/100);
    if(custom)custom.checked=selected.options.some(v=>v.includes('Custom name & number'));
    root.querySelectorAll('[data-option-index]').forEach(group=>{
      const index=Number(group.dataset.optionIndex);
      const value=selected.options[index].replace(suffix,'');
      const inputs=[...group.querySelectorAll('input')];
      (inputs.find(input=>input.value===value)||inputs[0]).checked=true;
    });
    function update(){
      const values=names.map((name,index)=>{
        if(index===personalisationIndex)return custom?.checked?'Custom name & number':'Standard';
        const value=root.querySelector('[data-option-index="'+index+'"] input:checked')?.value;
        return index===versionIndex&&custom?.checked?value+suffix:value;
      });
      const variant=product.variants.find(v=>v.options.every((value,i)=>value===values[i]));
      if(customFields){
        customFields.hidden=!custom.checked;
        customFields.querySelectorAll('input').forEach(input=>{input.disabled=!custom.checked;input.required=custom.checked;});
      }
      root.querySelectorAll('[data-stitched-extra]').forEach(el=>{
        const field=el.closest('[data-option-name]');
        el.hidden=field.dataset.optionName.toLowerCase()!=='version'||!values[versionIndex]?.startsWith('Stitched');
      });
      const add=root.querySelector('[data-add]');
      add.disabled=!variant?.available;
      if(variant){
        select.value=String(variant.id);
        root.querySelector('[data-price]').textContent=format(variant.price);
        const compare=root.querySelector('[data-compare]');
        compare.hidden=!(variant.compare_at_price>variant.price);
        compare.textContent=variant.compare_at_price?format(variant.compare_at_price):'';
        add.textContent=(variant.available?root.dataset.addLabel:root.dataset.unavailableLabel)+' · '+format(variant.price);
        const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
      }else{select.value='';add.textContent=root.dataset.unavailableLabel;}
    }
    root.querySelector('[data-js-options]').hidden=false;
    select.hidden=true;
    root.addEventListener('change',update);
    root.querySelector('[data-custom-name]')?.addEventListener('input',event=>{event.target.value=event.target.value.toUpperCase();});
    root.querySelector('[data-custom-number]')?.addEventListener('input',event=>{event.target.value=event.target.value.replace(/\D/g,'').slice(0,2);});
    root.querySelectorAll('[data-image]').forEach(button=>button.addEventListener('click',()=>{
      const image=root.querySelector('#ds-main-image');image.removeAttribute('srcset');image.src=button.dataset.image;
      root.querySelectorAll('[data-image]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
    }));
    form.addEventListener('submit',event=>{if(!select.value||root.querySelector('[data-add]').disabled)event.preventDefault();});
    update();
  });
}
initialiseDunkSupplyProducts();
document.addEventListener('shopify:section:load',initialiseDunkSupplyProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
